// Tab names - only "all" is still in use
export const ALL = "all";

// Page types
export const pageTypes = {
  FAQ: "Faq",
  WEBPAGE: "WebPage",
  DOCUMENT: "Document", // Literature item, i.e. PDF document
  ARTICLE: "Article", // News & views
  PEOPLE: "People", // All person types
  FUNDLIST: "FundList",
  FUNDEVENT: "FundEvent",
  DEFAULT: "Default", // ANything that hasn't be classified. Will be treated like WEBPAGE,
  VIDEO: "Video",
  TEAM: "Team",
  ASSET: "Asset",
};

// FundEvent types
export const fundEventTypes = {
  CAPITALDISTRIBUTION: "Capital distribution",
  CHARGESANDCOMMISSION: "Charges and commission",
  CLOSEDTONEWBUSINESS: "Closed to new business",
  CLOSURES: "Closures",
  LAUNCHES: "Launches",
  MERGERS: "Mergers",
  NAMECHANGES: "Name Changes",
  OBJECTIVEANDPOLICYCHANGES: "Objective and policy changes",
  OTHEREVENTS: "Other events",
  SUSPENSIONS: "Suspensions",
};

export const searchDefaults = {
  PAGE_SIZE: 12,
};

export const breakpoints = {
  mobileSearchFilters: 768,
  recentSearchBox: 768,
};

export default {
  ALL,
  pageTypes,
  breakpoints,
  defaultSearch: searchDefaults,
};
